import { MobileMenuSection } from './MobileMenuSection'
import { MobileMenuCategory } from './MobileMenuCategory'
import { MobileMenuLinks } from './MobileMenuLinks'
import { MOBILE_NAVIGATION_CONFIG } from './MobileMenuConfig'

interface MobileMenuContentProps {
  /** Callback function to close the mobile menu */
  setIsMobileMenuOpen: () => void
}

export const MobileMenuContent = ({ setIsMobileMenuOpen }: MobileMenuContentProps) => {
  return (
    <nav className="flex flex-col gap-1" role="navigation" aria-label="Mobile navigation">
      {/* Featured Links */}
      <section className="border-b border-gray-200 pb-2 mb-2" aria-labelledby="featured-links">
        <h2 id="featured-links" className="sr-only">Featured Links</h2>
        <MobileMenuLinks
          items={MOBILE_NAVIGATION_CONFIG.featuredLinks}
          onItemClick={setIsMobileMenuOpen}
          featured
        />
      </section>

      {/* Browse Magic Section */}
      <MobileMenuSection title="Browse Magic">
        {MOBILE_NAVIGATION_CONFIG.magicCategories.map(category => (
          <MobileMenuCategory
            key={category.title}
            title={category.title}
            items={category.items}
            onItemClick={setIsMobileMenuOpen}
          />
        ))}
      </MobileMenuSection>

      {/* Downloads Section */}
      <MobileMenuSection title="Magic Downloads">
        <MobileMenuLinks
          items={MOBILE_NAVIGATION_CONFIG.downloadCategories}
          onItemClick={setIsMobileMenuOpen}
        />
      </MobileMenuSection>

      {/* Exclusives Section */}
      <MobileMenuSection title="Exclusives">
        <MobileMenuLinks
          items={MOBILE_NAVIGATION_CONFIG.exclusiveCategories}
          onItemClick={setIsMobileMenuOpen}
        />
      </MobileMenuSection>

      {/* Other Links */}
      <section className="border-b border-gray-200 pb-2 mb-2 pt-2" aria-labelledby="other-links">
        <h2 id="other-links" className="sr-only">Other Links</h2>
        <MobileMenuLinks
          items={MOBILE_NAVIGATION_CONFIG.otherLinks}
          onItemClick={setIsMobileMenuOpen}
          featured
        />
      </section>
    </nav>
  )
}